import { Fragment } from "react";
import authenticatedLayout from "../component/layout/authenticatedLayout";
import NotePaper from "../component/notePaper/notePaper"
import Notebook from "../component/notebook/notebook"
const Dashboard = () => {
  return (
      <Fragment>
        <Notebook />
        <NotePaper />
      </Fragment>
  );
};

export const DashboardPage = authenticatedLayout(Dashboard);
